<template>
  <div class="admin-home">
    <p></p>
    <h1>Bienvenido al Panel del del empleado</h1>
    <p>Esta es la pantalla de inicio. Desde aquí puedes acceder a las distintas opciones, gestion reservacion de traslados, pagos, etc.</p>
  </div>
</template>

<script>
export default {
  name: 'EmpleadoHome',
};
</script>

<style scoped>
.admin-home {
  text-align: center;
  padding: 150px;
}

h1 {
  color: #29b39c;
  margin-bottom: 20px;
}

p {
  color: #555;
}
</style>